import { Color, PANTONES } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IPantoneExampleProps {
   value: Color
   field: any
   onChange: (color: any) => void
}
const PantoneExample = (props: IPantoneExampleProps): JSX.Element => {
    return <div>
        <div className='d-flex flex-wrap w_225'>
            {
                Object.values( PANTONES ).map(pn => { 
                    return <div 
                        className={ `pantone-example ${ `var(${ pn })` === props.value?.toString() ? "active" : "" }` } 
                        style={{ background: `var(${ pn })` }} 
                        key={ pn } 
                        onClick={ () => props.onChange( `var(${ pn })` ) }
                    />
                })
            }
            <div 
                className={ `pantone-example ${ "transparent"  === props.value?.toString() ? "active" : "" }` } 
                style={{ background: "transparent" }}
                onClick={ () => props.onChange( `${ "transparent" }` ) }
            />
        </div>
        <div className="smallest letter-spacing-1 p-1">
            {__("Collection of preset colors, the shade of which depends on the interface theme.")}
        </div>
    </div>
}
export default PantoneExample